
/* Nav scroll effect */
(function(){
  var nav=document.getElementById('nav');
  if(!nav)return;
  window.addEventListener('scroll',function(){
    nav.classList.toggle('scrolled',window.scrollY>10);
  });
})();

/* Announcement bar dismiss */
(function(){
  var btn=document.querySelector('.ann .x');
  if(btn)btn.addEventListener('click',function(){
    this.closest('.ann').classList.add('gone');
  });
})();

/* Mobile drawer toggle */
function toggleDrawer(){
  document.getElementById('drawer').classList.toggle('open');
  document.getElementById('drawerOverlay').classList.toggle('open');
}

/* Update cart count on load */
(function(){
  fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
    var el=document.getElementById('cartCount');
    if(el && c.item_count>0){
      el.textContent=c.item_count;
      el.classList.add('on');
    }
  }).catch(function(){});
})();
